<template>
    <div class="the-topics" :style="containerStyle">
        <Transition :name="transitionName" mode="out-in">
            <Component :is="topicGroupComponent"/>
        </Transition>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import layoutMixin from '@/mixins/layoutMixin'
import { capitalize, camelCase } from 'lodash'

import topicGroupComonents from './TopicGroupComponents'

export default {
    mixins: [layoutMixin],

    components: {
        ...topicGroupComonents
    },

    computed: {
        ...mapState(['scene']),

        mobile() {
            return this.w < 750
        },

        topicGroupComponent() {
            let component = `TopicGroup${capitalize(this.scene)}`
            return topicGroupComonents[component] ? component : null
        },

        transitionName() {
            return `slide-${this.layout}`
        },

        top() {
            return this.small ? 80 : 50
        },

        containerStyle() {
            return {
                width: this.horizontal ? '50%' : '100%',
                height: this.horizontal ? '100%' : '50%',
                paddingLeft: this.scene === 'technology' ? 0 : null
            }
        }
    }
}
</script>

<style lang="stylus">
#sign-up-button
    cursor: pointer

#sign-up-button:hover
    & > path
        fill: white

#the-topics svg
    cursor: pointer
</style>

<style  scoped>
.the-topics {
    position: fixed;
    box-sizing: border-box;
    bottom: 0;
    right: 0;
    padding: 25px 5%;
    pointer-events: none;
}

@media (min-width: 600px) {
    .the-topics {
        padding: 40px 5%;
    }
}

.slide-horizontal-enter,
.slide-horizontal-leave-to {
    transform: translateX(50vw);
    opacity: 0;
}

.slide-horizontal-enter-active,
.slide-horizontal-leave-active {
    transition: opacity 0.3s, transform 0.3s;
}

.slide-vertical-enter,
.slide-vertical-leave-to {
    transform: translateY(50vh);
    opacity: 0;
}

.slide-vertical-enter-active,
.slide-vertical-leave-active {
    transition: opacity 0.3s, transform 0.3s;
}
</style>

